module.exports = __webpack_public_path__ + "static/b2bcustomers-c371f4c1c7e61b93ff7d7a43071ce8b7.png";